<h1 mat-dialog-title *ngIf="!isBusy" xmlns="http://www.w3.org/1999/html">Edit Event Title</h1>
<div *ngIf="!isBusy; else spinner" class="event-edit-name__form-container">
  <fieldset class="event-edit-name__form-section">
    <legend class="event-edit-name__form-section-title">Event Title</legend>
    <mat-dialog-content [formGroup]="formGroup">
      <mat-form-field class="event-edit-name__formItem">
        <input matInput
               placeholder="Event Title *"
               formControlName="title" [(ngModel)]="aviationEvent.title" maxlength="256">
      </mat-form-field>
    </mat-dialog-content>
  </fieldset>
  <mat-dialog-actions class="form-formatting">
    <button type="submit" [disabled]="!formGroup.valid" id="saveButton" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template #spinner>
  <div class="spinnerContainer">
    <mat-spinner  class="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </div>
</ng-template>
